import * as yup from 'yup'
import { mediaSchema } from '@/components/inputs'

export const schema = yup.object({
  specie: yup.string().required(),
  amount: yup.number().required(),
  plant_stage: yup.string().required(),
  notes: yup.string().max(256),
  observed_at: yup.date().required(),
  photos: mediaSchema,
})
